'use client'
import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'
import styles from './CoverBlob.module.scss'
import { useErrorHandling } from '@/tools/o11y/client'
import type { IllustrationBlobProps } from '@/tools/ui'
import { Illustration } from '@/tools/ui'

export const CoverBlob: React.FC<IllustrationBlobProps> = ({
  className,
  shape,
  src,
  alt,
  ...props
}) => {
  const { execWithErrorTracking } = useErrorHandling()
  const pathRef = useRef<HTMLDivElement>(null)
  const ShapeComponent = shape
  const [clipPath, setClipPath] = useState('')

  useEffect(() => {
    execWithErrorTracking(() => {
      if (pathRef.current) {
        const pathElement = pathRef.current.querySelector('svg path')
        if (pathElement) {
          const pathData = pathElement.getAttribute('d')
          setClipPath(`path('${pathData}')`)
        }
      }
    })
  }, [execWithErrorTracking])

  return (
    <div className={classNames(styles.blob, className)}>
      <div ref={pathRef}>{ShapeComponent && <ShapeComponent className={styles.shape} />}</div>
      <div
        className={styles.image}
        style={{ clipPath: clipPath || 'none', visibility: clipPath ? 'visible' : 'hidden' }}
      >
        <Illustration alt={alt} src={src} {...props} className={styles.illustration} />
      </div>
    </div>
  )
}
